module.exports = __webpack_public_path__ + "img/bkimg.c47f934.png";